import React, { useState } from "react";
import { Avatar, Dropdown, Popover } from "antd";
import { getQuestionAndAnswerInText, handleError, momentit, NewgetQuestionAndAnswerInText } from "../../utils";
// import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { ReactComponent as HeartIcon } from "../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../Icons/heartSelect.svg";
import { useDispatch, useSelector } from "react-redux";
// import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfWhiteIcon.svg";
import { deleteAnswerrecord, fetchAttachmentURL, getQuestionDraftData, getTabSearchData, getTrendingData, markUnmarkFavourite } from "../../API/api";
import { ReactComponent as ShareIcon } from "../../Icons/share.svg";
import { ReactComponent as CopyIcon } from "../../Icons/copy.svg";
// import Button2 from "../../Button2/Button2";
// import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
// import Button2 from "../../NewComponent/Button2/Button2";

// import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Button2 from "../../NewComponent/Button2/Button2";
// import AttachmentBox from "../../../NewComponent/AttachmentBox/AttachmentBox";

import { useLocation, useNavigate } from "react-router-dom";
import { DeleteOutlineOutlined, EditOutlined, FavoriteBorderOutlined, LocalFireDepartment, PeopleAltOutlined } from "@mui/icons-material";
import { CURRENT_ROLE } from "../../API/url";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { toast } from "react-toastify";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import styles from './Styles.module.css'
import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";


export default function Question({ question, tabsearchQuery, curationFilter, fetchData, fetchDataCount }) {
  // console.log("question",question)
  const name = "answeredQuestions";
  let pageState = useSelector((state) => state[name]);
  const dispatch = useDispatch();
  const { updateRatingBoolean, getScrollPositionInExpertOpen, updatePageNoAnswered, updateAnsweredTabData, advanceFilterModalToggle, savePageNumberAnswer, getSelectedQuestion, markedTrendingData, markedAnsweredData, markedFavData, markedSharedByData, markedSharedWithData, updateKeyTagData, questionDataForEditor, updateAnswerTextForEditor, updateSubmissionTypeForEditor, updateAttachmentForEditor, recommendData, updateCheckBoxValForEditor, filteringSearchData, getSeekerAttachment, preservePreviousRecommendData } =
    bindActionCreators(Actions, dispatch);
  const searchState = useSelector((state) => state.search);
  const trendingState = useSelector((state) => state.trending);
  const answeredState = useSelector((state) => state.answeredQuestions);
  const favouriteState = useSelector((state) => state.favouriteQuestions);
  const currentPath = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const sharedByState = useSelector((state) => state.sharedBy);
  const sharedWithState = useSelector((state) => state.sharedWith);
  const tagState = useSelector((state) => state.keyTag);
  const userState = useSelector((state) => state.user);
  const [isFavorite, setFavorite] = useState(question.favourite);
  const editorState = useSelector((state) => state.editor);
  const navigate = useNavigate();
  const [isFavourite, setIsFavourite] = useState(question.favourite);
  const onCLickFavorite = (key, flag) => {
    markUnmarkFavourite(key.origQuestionUuid).then((res) => {
      if (res === undefined) return;
      setFavorite(flag);
      searchState.expertData.filter(obj => {
        if (obj.origQuestionUuid === key.origQuestionUuid) {
          obj.favourite = flag;
        }
      })
    });
  };
  const isCheckRelevance = (str) => {
    let isThere = false;
    for (let i = 0; i < str.length; ++i) {
      if (str[i].label === "Relevance") {
        isThere = true;
      }
    }
    return isThere;
  };
  const infoContainer = {
    display: "flex",
    alignItems: "center",
    gap:"7px"
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom:'5px'
    // paddingLeft: "7px",

  };

  const textStyles = {
    fontSize: "24px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word', overflowWrap: 'break-word',
    cursor: isHovered ? question.reusableThreadQA ? 'default' : 'pointer' : '',
    textDecoration: isHovered ? question.reusableThreadQA ? 'none' : 'underline' : '',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const confidenceStyles1 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #F59B00",
    borderRadius: "6px",
    backgroundColor: "#F59B00",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const confidenceStyles2 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #00A3FF",
    borderRadius: "6px",
    backgroundColor: "#00A3FF",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };



  const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };
  const successfulDeleteQuestion = (message) => {
    return (
      <span style={{ fontSize: '12px' }}>{message}</span>
    )
  }
  const convertStringToEpoch = (dt) => {
    let date = Date.parse(dt);
    return date;
  }
  const isAnsweredByMe = (arr) => {
    let id = ""
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        updateCheckBoxValForEditor({ flag: obj.internal, key: "internal" });
        updateCheckBoxValForEditor({ flag: obj.privacy, key: "isUpdateKB" });
        id = obj.answerUuid;
      }
    })
    return id;
  }

  const isAnsweredByMeAttachment = (arr) => {
    let text = []
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        text = obj.attachments;
      }
    })
    return text;
  }

  const deleteAnswer = (question) => {

    getScrollPositionInExpertOpen(null)
    let answerUuid = question.answersList.map(data => {
      if (data.expertUuid === userState.geoAttributes.userId) {
        return data.answerUuid;
      }
    })
    let updatedData = answeredState.data = answeredState.data.filter(obj => {
      if (obj.questionUuid !== question.questionUuid) {
        return obj;
      }
    });
    let id = (arr) => {
      let data = []
      let uuid = "";
      arr.filter(ids => {
        if (ids !== undefined) {
          uuid = ids;
        }
      })

      let val = { answerUuidStr: uuid };
      data.push(val)
      return data
    }
    let deleteuuid = [];
    deleteuuid.push(answerUuid);
    // console.log("delete",deleteuuid)
    deleteAnswerrecord(id(answerUuid)).then(res => {
      if (res === undefined) return;
      if (res.data.success) {
        toast.success(successfulDeleteQuestion(res.data.message), {
          position: toast.POSITION.TOP_RIGHT
        });
        if (pageState.pageNo === 0) {
          fetchData();

        }
        if (pageState.pageNo !== 0) {
          updatePageNoAnswered(0);
        }
        fetchDataCount();
      }

      // markedAnsweredData(updatedData);

    })
    // fetchDataCount();

  }

  const updateFavouriteData = (data) => {
    // if(currentPath.pathname.includes('/search')){
    //   updateSearchData(data);
    // }
    if (currentPath.pathname.includes('/trending')) {
      markedTrendingData(data)
    }
    if (currentPath.pathname.includes('/answered')) {
      markedAnsweredData(data)
    }
    if (currentPath.pathname.includes('/favourite')) {
      markedFavData(data)
    }
    if (currentPath.pathname.includes('/sharedby')) {
      markedSharedByData(data)
    }
    if (currentPath.pathname.includes('/sharedwith')) {
      markedSharedWithData(data)
    }
    if (currentPath.pathname.includes('/tagdata')) {
      updateKeyTagData(data)
    }
  }

  const appendInlineImageInText = async (arr) => {
    let newArr = await arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        if (obj.inlineImages.length > 0) {
          for (let i = 0; i < obj.inlineImages.length; ++i) {
            let pld = { name: obj.inlineImages[i] }
            fetchAttachmentURL(pld).then(res => {
              if (res === undefined) return;
              if (obj.inlineImages[i].includes(".png")) {
              } else {
                let imgTag = `<img style='max-width:50%' src=${res.data.data.src
                  }></img>`;

                let replacedContent = obj.inlineImages[i];
                obj.answerCopy = obj.answerCopy.replaceAll(
                  replacedContent,
                  imgTag
                );
                updateAnswerTextForEditor(obj.answerCopy);
              }
            })
          }
        }

        return obj;
      }
    })
    updateAnswerTextForEditor(newArr.length === 0 ? "" : newArr[0].answerCopy);
  }

  const onClickShareButton = (question) => {
    getScrollPositionInExpertOpen(window.scrollY)
    advanceFilterModalToggle({ bool: true, value: "shareQuestion" });
    getSelectedQuestion(question);
  };


  const excludedValues = ['transferred', '1', '2', '3']; // Exclude these from filteredDomains
  const curationValues = ['1', '2', '3']; // Values for curationCategory
  // const prevDeps = useRef({});
  const isTransferred = pageState.domains.some(domain => domain.value === 'transferred'); // Check if 'transferred' exists

  const filteredDomains = pageState?.expertDomain?.filter(domain => !excludedValues.includes(domain.value)); // Remove 'transferred', '1', '2', '3'
  const curationCategory = pageState.expertCuration
    ?.filter(domain => curationValues.includes(domain.value)) // Get only '1', '2', '3'
    ?.map(domain => domain.value); // Extract values

  // console.log("curationCategory", filteredDomains)
  const searchCuration = curationCategory.length > 0 ? curationCategory.map(Number).join(",") : "";

  const searchDomain = filteredDomains.length > 0 ? curationCategory : "";

  //  const fetchData = () => {
  //       if (name === "answeredQuestions") {
  //           if (
  //               tabsearchQuery.length === 0 &&
  //               !isCheckRelevance(pageState.sortOptions)
  //           ) {
  //               const isTransferred = pageState.domains.some(domain => domain.value === 'transferred');
  //               IsLoadingAnsweredtab(true);
  //               getTrendingData(
  //                   pageState.pageNo !== undefined ? pageState.pageNo : 0,
  //                   pageState.sortFilter.origValue,
  //                   pageState.sortFilter.sortOrder !== undefined ? pageState.sortFilter.sortOrder : pageState.sortOrder,
  //                   pageState.sortChange,
  //                   filteredDomains, // Filter out 'transferred'
  //                   "answered",
  //                   CURRENT_ROLE === "Expert" ? curationCategory : null,
  //                   CURRENT_ROLE === "Expert" ? isTransferred : null,
  //                   CURRENT_ROLE === "Expert" ? "pending" : null
  //               ).then((res) => {
  //                   if (res === undefined) return;
  //                   if (res.data.success) {

  //                       updateAnsweredTabData({
  //                           data: res.data.data,
  //                           count: res.data.count,
  //                       });
  //                       IsLoadingAnsweredtab(false);
  //                   }
  //               })
  //                   .catch((err) => {
  //                       handleError(err);
  //                   });
  //           }
  //           if (
  //               tabsearchQuery.length !== 0 &&
  //               isCheckRelevance(pageState.sortOptions)
  //           ) {
  //               IsLoadingAnsweredtab(true);

  //               getTabSearchData(
  //                   pageState.pageNo !== undefined ? pageState.pageNo : 0,
  //                   "answered",
  //                   pageState.sortFilter.origValue,
  //                   tabsearchQuery,
  //                   pageState.sortFilter.sortOrder !== undefined ? pageState.sortFilter.sortOrder : pageState.sortOrder,
  //                   pageState.sortChange,
  //                   filteredDomains,
  //                   null,
  //                   CURRENT_ROLE === "Expert" ? searchCuration : null, // Spread the numbers as separate arguments
  //                   CURRENT_ROLE === "Expert" ? isTransferred : null,
  //                   CURRENT_ROLE === "Expert" ?curationFilter  : null
  //               ).then((res) => {
  //                   if (res === undefined) return;
  //                   if (res !== undefined && res.data.success) {
  //                       IsLoadingAnsweredtab(false);
  //                       updateAnsweredTabData({
  //                           data: res.data.data,
  //                           count: res.data.count,
  //                       });
  //                   }
  //               });
  //           }
  //       } 

  //   };




  const onClickMarkFavorite = (flag) => {
    // console.log("flag",flag)
    setFavorite(!flag)
    getScrollPositionInExpertOpen(window.scrollY)
    let filteredData1 = [];
    let filteredData2 = []

    markUnmarkFavourite(question.questionUuid)
      .then((res) => {
        // updateFavouriteData(filteredData)
        fetchData()
        fetchDataCount();
      })
      .catch((err) => { });
  }


  const editAnswer = (question) => {
    // console.log("this question",  pageState.pageNo)
    getScrollPositionInExpertOpen(null)
    savePageNumberAnswer(pageState.pageNo)
    updateRatingBoolean(true)
    let data = question;
    if (data.questionText === undefined) {
      data.questionText = data.question;
    }
    if (currentPath.pathname.includes('/search')) {
      data.questionUuid = data.origQuestionUuid;
    }
    if (data.seekerAttachments && data.seekerAttachments !== null) {
      getSeekerAttachment(data.seekerAttachments)
    }
    updateAttachmentForEditor(isAnsweredByMeAttachment(data.answersList))
    let isAnswerUuid = isAnsweredByMe(data.answersList);
    editorState.answerUuid = isAnsweredByMe(data.answersList);
    updateSubmissionTypeForEditor(isAnswerUuid === '' ? 'answer' : 'update');
    data.questionPostedTimestamp = data.questionPostedTimestamp === undefined ? data.postedTimestamp : data.questionPostedTimestamp;
    data.questionStatus = 'answered';
    data.questionPostedTimestamp = typeof (data.questionPostedTimestamp) === 'string' ? convertStringToEpoch(data.questionPostedTimestamp) : data.questionPostedTimestamp;
    questionDataForEditor(data);
    getQuestionDraftData(data.questionUuid).then(res => {
      if (res === undefined) return;
      if (res.data.data.length > 0) {
        updateAnswerTextForEditor(res.data.data[0].answer);
      } else {
        appendInlineImageInText(data.answersList);
      }
    })
    getScrollPositionInExpertOpen(window.scrollY)
    navigate('/expertHome/editor');
  }
  const copyQA = (question) => {
    getScrollPositionInExpertOpen(null);
    let data = NewgetQuestionAndAnswerInText(question);

    // Convert <a href="...">label</a> to "label (url)"
    data = data.replace(/<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/gi, '$2 ($1)');

    // Remove <a id="..."></a> empty anchor tags
    data = data.replace(/<a\s+id=".*?"\s*><\/a>/gi, '');

    // Remove all remaining HTML tags
    const validHTMLTagsTextArea = /<(\/?\w+)[^>]*>/gim;
    data = data.replace(validHTMLTagsTextArea, ' ');

    // Remove inline styles
    data = data.replace(/style=".*?"/gi, '');

    // Add newline before each "Answer" (e.g., "Answer1:", "Answer 2:")
    data = data.replace(/\s*(answer\s*\d+:)/gi, '\n$1');

    // Optional: Add newline before each "Question" (e.g., "Question1:", "Question 2:")
    data = data.replace(/\s*(question\s*\d+:)/gi, '\n$1');

    // Remove UUIDs (e.g., 123e4567-e89b-12d3-a456-426614174000)
    data = data.replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:_\d+)?\b/gi, '');

    // Collapse multiple spaces into one and trim
    const cleanedText = data.replace(/\s{2,}/g, ' ').trim();

    // console.log(cleanedText);
    window.navigator.clipboard.writeText(cleanedText);

    toast.success('Copied!', {
      position: toast.POSITION.TOP_RIGHT,
      style: {
        width: '300px',
        height: '20px',
        fontSize: '12px',
      },
    });
  };

  const onClickFavorite = (flag) => {

    markUnmarkFavourite(question.questionUuid).then((res) => {
      if (res === undefined) return;
      // getExpertOpenData(filteredData);
      setIsFavourite(!isFavourite);
    }).catch(err => handleError(err));
  }

  // console.log("isFavorite",isFavorite)
  // savePageNumberAnswer(e-1)
  const DropdownComponent = ({ question }) => {
    const items = [
      {
        key: "1",
        label: (
          <span style={{ display: "flex", alignItems: "center" }}>
            <a onClick={() => editAnswer(question)}>
              <EditOutlined style={{ fontSize: "18px", margin: "3px" }} />
              Edit
            </a>
          </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "2",
        label: (
          <span style={{ display: "flex", alignItems: "center" }}>
            <a onClick={() => deleteAnswer(question)}>
              <DeleteOutlineOutlined style={{ fontSize: "18px", margin: "3px" }} />
              Delete
            </a>
          </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "3",
        label: (
          <span style={{ display: "flex", alignItems: "center" }}>
            <a onClick={() => onClickMarkFavorite(question.favourite)}>
              <FavoriteBorderOutlined
                style={{
                  fontSize: "18px",
                  margin: "3px",
                  color: isFavorite && '#FF6A00',
                }}
              />
              Favorite
            </a>
          </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "4",
        label: (
          <span style={{ display: "flex", alignItems: "center" }}>
            <a onClick={() => onClickShareButton(question)}>
              <ShareIcon style={{ fontSize: "16px", margin: "3px" }} />
              Share
            </a>
          </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "5",
        label: (
          <span style={{ display: "flex", alignItems: "center" }}>
            <a onClick={() => copyQA(question)}>
              <CopyIcon style={{ fontSize: "16px", margin: "3px" }} />
              Copy
            </a>
          </span>
        ),
      },

    ];

    return (
      <>
        <Dropdown menu={{ items }}>
          <img
            src={require("../../Images/dots-vertical.png")}
            style={{ cursor: "pointer" }}
          />
        </Dropdown>
      </>
    );
  };

  const onClickEdit = () => {
    // console.log(question.answersList);
  }


  const generatingRelatedQ = (data) => {
    // console.log("number",pageState.pageNo)
    savePageNumberAnswer(pageState.pageNo)
    getScrollPositionInExpertOpen(window.scrollY)

    if (data.text === undefined) {
      data.text = data.questionText;
    }
    if (!data.reusableThreadQA) {
      let payload = {
        data: {
          id: data.questionUuid,
          text: data.text
        }
      }
      preservePreviousRecommendData([])
      recommendData(payload);
      navigate(`${Home_PAGE_URL}recommend`);
    } else if (data.reusableThreadQA) {
      if (data.status === 'accepted') {
        let payload = {
          data: {
            id: data.questionUuid,
            text: data.text
          }
        }
        preservePreviousRecommendData([])
        recommendData(payload);
        navigate(`${Home_PAGE_URL}recommend`);
      }
    }

  }
  // console.log("question",question)
  return (
    <>
      <div style={infoContainer}>
        <div style={dateInfoStyles}>
          <div className={styles.questionText} onClick={() => generatingRelatedQ(question)} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} >
            {question.questionText}
          </div>
       
          <div style={infoContainer}>
          {
            question.seekerAttachments &&
            question.seekerAttachments.length > 0 && (
              <div style={{}}>
                <Popover title={renderAttachemnt(question.seekerAttachments)}>
                  {" "}
                  <Button2 onClickFunc={onCLickFavorite}>
                    <DownloadIcon />
                  </Button2>
                </Popover>
              </div>
            )}
            {/* {question.seekerAttachments && question.seekerAttachments.length > 0 && (
                  <Popover title={renderAttachemnt(question.seekerAttachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>)} */}
            <DropdownComponent question={question} />
            {/* {
                isFavorite ? (
                    <div style={{ marginRight: "6px", cursor: "pointer" }}>
                      <HeartSelectedIcon
                        onClick={() => onCLickFavorite(question, false)}
                      />
                    </div>
                  ) : (
                    <div style={{ marginRight: "6px", cursor: "pointer" }}>
                      <HeartIcon onClick={() => onCLickFavorite(question, true)} />
                    </div>
                  )
                  } */}
            {/* {question.isShowUpdateRequestWarning && <div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{ fontSize: '22px', color: '#F59B00', marginRight: '5px', cursor: 'pointer' }}></i></span></TooltipComp>
            </div>}
            {!currentPath.pathname.includes('/open') && <div
              style={
                question.confidence ? confidenceStyles2 : confidenceStyles1
              }
            >
              {question.docType === "expertqa" ? (
                "Q&A"
              ) : (
                <>
                  <PdfWhiteIcon style={{ marginBottom: "4px" }} />
                </>
              )}
            </div>} */}
            {/* {CURRENT_ROLE==='Expert'&&<div>&nbsp;&nbsp;<i className="fa fa-edit" style={{fontSize:'20px', marginTop:'5px', color:'#ACB6C6', cursor:'pointer'}} onClick={()=>onClickEdit()}></i></div>} */}
          </div>
        </div>

      </div>
      <span style={{ color: '#5C667B', fontWeight: 400, fontSize: '14px', marginTop: '5px', marginBottom: '5px' }}>Asked&nbsp;{" "}{momentit(question?.questionPostedTimestamp)}</span>

      {/* <span style={{color:'#5C667B',fontSize:'12px',fontWeight:400}}>Last Reviewed{" "}{momentit(question.postedTimestamp)}</span> */}
    </>
  );
}
